"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var navPopoverBaseTheme = function (_breakpoints) { return ({
    navPopoverTitle: {
        fontSize: "inherit",
    },
    navPopoverHomeHref: {
        flexBasis: "100%",
        textDecoration: 'none',
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
        marginBottom: "0.5rem",
        "& i18n-message": {
            paddingLeft: "0.5rem",
            lineHeight: "0.35rem"
        }
    },
    navPopoverHomeHrefText: {
        whiteSpace: 'nowrap',
        fontSize: "0.875rem",
        padding: "1.25rem 1rem 0.625rem 0",
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center'
    },
    navPopoverHomeHrefIcon: {
        display: 'flex',
        verticalAlign: "middle",
        fontSize: "1rem",
        "& i18n-message": {
            display: 'inline'
        }
    },
    navPopover: {
        maxWidth: "60rem",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "flex-start",
        padding: "0.5rem",
        "& a:hover": {
            textDecoration: 'none',
        }
    },
    navPopoverHref: {
        flex: "0 0 33%",
        textDecoration: "none",
        padding: "0.25rem",
        alignItems: "center",
        display: "flex"
    },
    navPopoverIcon: {
        width: "1rem",
        marginRight: "0.5rem"
    },
    navPopoverHrefText: {
        alignSelf: "center",
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center'
    },
}); };
exports.default = navPopoverBaseTheme;
//# sourceMappingURL=navPopover.js.map